import styled, { css } from 'styled-components';
import { CheckboxProps } from './checkbox.types';

export const Checkbox = styled.button(
  ({ theme: { color } }) => css`
    width: 16px;
    height: 16px;
    border: 1px solid ${color.ui4};
    padding: 2px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: inherit;
    transition: 150ms all;
    border-radius: 1px;

    outline-offset: 2px;
    outline: 2px solid;
    outline-color: transparent;

    fill: ${color.s1};

    &:hover {
      fill: ${color.s2};
    }
    &:focus {
      border: 1px solid ${color.s1};
    }
  `,
);

export const Container = styled.div<{ disabled: CheckboxProps['disabled'] }>(
  ({ disabled }) => css`
    display: flex;
    align-items: center;

    user-select: none;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    opacity: ${disabled ? '0.5' : '1'};

    gap: 8px;
  `,
);

export const Label = styled.div(
  ({ theme: { color, font } }) => css`
    ${font.t2}
    color: ${color.ui2};
  `,
);
